<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width: 100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5" id="grad1">
                <!-- breadcrumb and title row starts -->
                <div class="row">
                    <div class="col-sm-12">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard',
                  },

                  {
                    title: 'Event Wizard',

                  },
                  {
                    title: ` ${updateTraining.title} ${formatDateRange(updateTraining.startdate, updateTraining.enddate)}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Event Wizard</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <div class="row justify-content-center mt-0">
                    <div class="col-11 text-center p-0 mt-3 mb-2">
                        <div class="card px-0 pb-0 mt-3 mb-3">
                            <div class="row">
                                <div class="col-md-12 mx-0">
                                    <form id="msform">
                                        <!-- progressbar -->
                                        <ul id="progressbar">
                                            <li title="Warning! You are not authorized to access." id="NewTraining">
                                                <strong>Event Assignment</strong>
                                            </li>
                                            <li title="Warning! You are not authorized to access." id="PoAssignment">
                                                <strong>P.O Assignment</strong>
                                            </li>
                                            <li @click="trainingInformation()" class="completed" id="TrainingInformation">
                                                <strong>Event Information</strong>
                                            </li>
                                            <li class="active" id="TrainerRegistration">
                                                <strong>Facilitators' Registration</strong>
                                            </li>
                                            <li @click="trainingAgenda()" id="TrainingAgenda">
                                                <strong>Event Agenda</strong>
                                            </li>
                                            <li @click="trainingMaterial()" id="Trainingmaterial">
                                                <strong>Upload Material</strong>
                                            </li>
                                            <li @click="trainingAssessment()" id="TrainingAssessments">
                                                <strong>Assessments</strong>
                                            </li>

                                            <li @click="traineeReg()" id="TraineeRegistration">
                                                <strong>Participants' Registration</strong>
                                            </li>
                                            <li @click="assessmentReviewFunction()" id="AssessmentReview">
                                                <strong>Review</strong>
                                            </li>
                                            <li @click="trainingCompletion()" id="Completion">
                                                <strong>Completion</strong>
                                            </li>
                                        </ul>
                                        <!-- fieldsets -->
                                        <fieldset style="text-align: left; padding: 20px">
                                             <!-- Next Step Button Starts  -->
                                             <div class="row">
                                                                <div class="col-md-12 text-right">
                                                                    <router-link :to="{
                                        path: '/dashboard/programOfficer/training-Information',
                                        query: {
                                          trainingId: this.trainingCode,
                                        },
                                      }" class="btn btn-primary btn-sm m-1" v-if="isDateValid">Previous Step</router-link>
                                                                    <router-link :to="{
                                        path: '/dashboard/programOfficer/training-agenda',
                                        query: {
                                          trainingId: this.trainingCode,
                                        },
                                      }" class="btn btn-primary btn-sm" :class="{ disabled: newTrainer.length === 0 }">Next Step</router-link>
                                                                    <button type="button" v-on:click="allTrainer()" class="btn btn-primary btn-sm m-1">
                                                                        <vs-icon icon="refresh" title="Refresh"></vs-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                            <vs-tabs class="custom-tabs" alignment="fixed">
                                                <vs-tab label="Quick Facilitator Registration" @click="clearSearch()">
                                                    <div class="row">
                                                        <b-card v-if="isForm">
                                                            <form @submit.prevent="quickRegistration" v-if="isDateValid">
                                                                <!--Detail Information starts -->
                                                                <div class="form-group form-row">
                                                                    <div class="col-sm-6 mb-2">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" type="text" placeholder=" " v-model="name" autocomplete="off" @input="name = name.replace(/[^a-zA-Z\s]/g, '')" id="name" />
                                                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                                                <i class="material-icons" style="font-size: 20px">account_circle</i>
                                                                            </span>
                                                                            <label class="lbl-label">
                                                                                Facilitator Name
                                                                                <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-2">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" v-mask="'(9999)-9999999'" type="text" placeholder=" " v-model="mobilenumber" id="contact" />

                                                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                                                <i class="material-icons" style="font-size: 20px">call</i>
                                                                            </span>
                                                                            <label class="lbl-label">
                                                                                Contact
                                                                                <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <!---start  -->
                                                                    <div class="col-md-6">
                                                                        <div class="form-group">
                                                                            <label style="font-weight: 700" for="first">
                                                                                Department
                                                                            </label>
                                                                            <selectize id="select-state department" class="text-capitalize" v-model="department" :settings="departmentSetting" :searchable="true">
                                                                                <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                    {{item.title}}
                                                                                </option>
                                                                            </selectize>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <div class="form-group">
                                                                            <label style="font-weight: 700" for="first">
                                                                                Designation
                                                                            </label>
                                                                            <selectize id="select-state designation" class="text-capitalize" v-model="designation" :settings="designationSetting" :searchable="true">
                                                                                <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                    {{item.title}}
                                                                                </option>
                                                                            </selectize>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6">
                                                                        <div class="form-group">
                                                                            <label style="font-weight: 700" for="first">
                                                                                Nationality
                                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                            </label>
                                                                            <selectize id="select-state nationality" class="text-capitalize" v-model="nationality" :searchable="true">
                                                                                <option v-for="(item,index) in nationalityArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                    {{item.name}}
                                                                                </option>
                                                                            </selectize>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6">
                                                                        <div class="form-group">
                                                                            <label style="font-weight: 700" for="first">
                                                                                Qualification
                                                                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                            </label>
                                                                            <selectize id="select-state qualification" class="text-capitalize" v-model="academicqualifications" :searchable="true">
                                                                                <option v-for="(item,index) in qualificationArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                    {{item.title}}
                                                                                </option>
                                                                            </selectize>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-2 mt-2">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" v-mask="'(99999) 9999999-9'" type="text" placeholder=" " v-model="cnic" autocomplete="off" :disabled="nationality != 1" id="cnic" />

                                                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                                                <i class="material-icons" style="font-size: 20px">credit_card</i>
                                                                            </span>
                                                                            <label class="lbl-label">
                                                                                CNIC
                                                                                <span v-if="nationality == 1" style="color: rgba(255, 0, 0, 0.78)">*</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-2 mt-2">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" type="text" placeholder="" v-model="address" id="address" />

                                                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                                                <i class="material-icons" style="font-size: 20px">home</i>
                                                                            </span>
                                                                            <label class="lbl-label">
                                                                                Address
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <!---end  -->

                                                                    <div class="col-sm-6 mb-2 mt-3">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" v-model="passport" type="text" placeholder=" " id="passport" />
                                                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                                                <i class="material-icons" style="font-size: 20px">credit_card</i>
                                                                            </span>
                                                                            <label class="lbl-label">
                                                                                Passport
                                                                                <!--  <span style="color:rgba(255, 0, 0, 0.78);">*</span> -->
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-2 mt-3">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" type="email" placeholder=" " v-model="email" id="email" />

                                                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                                                <i class="material-icons" style="font-size: 20px">email</i>
                                                                            </span>
                                                                            <label class="lbl-label">
                                                                                Email
                                                                                <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6 col-lg-6 mb-2 mt-3">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" v-model="code" type="text" placeholder=" " id="code" />

                                                                            <span class="lbl-label" style="
                                            float: right;
                                            margin-top: -25px;
                                            padding: 0px 5px;
                                            color: #ccc;
                                          ">
                                                                                <i class="material-icons" style="font-size: 20px">code</i>
                                                                            </span>
                                                                            <label class="lbl-label">
                                                                                Employee Code (This will use as
                                                                                password)
                                                                                <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6 col-lg-6 mb-2 mt-3">
                                                                        <!-- Gender starts -->
                                                                        <div style="padding-left: 5px; display: inline-flex; color: #1465a3">
                                                                            <label class="col-form-label" style="font-weight: 700;">
                                                                                Gender
                                                                                <span style="color:rgba(255, 0, 0, 0.78)">*</span>
                                                                            </label>
                                                                            <div style="margin: 7px 6px 2px 6px">
                                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="male" id="male">Male</vs-radio>
                                                                            </div>
                                                                            <div style="margin: 7px 6px 2px 6px">
                                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="female" id="female">Female</vs-radio>
                                                                            </div>
                                                                            <div style="margin: 7px 6px 2px 6px">
                                                                                <vs-radio v-model="gender" vs-name="radios1" vs-value="rather not say" id="gender">Rather not say</vs-radio>
                                                                            </div>
                                                                        </div>
                                                                        <!-- Gender ends -->
                                                                    </div>
                                                                    <div class="col-sm-6 mt-3 mb-2">
                                                                        <div class="floating-label">
                                                                            <input class="floating-input form-control" hidden type="text" placeholder=" " v-model="role" id="role" />

                                                                            <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          "></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!--Detail Information ends -->

                                                                <!-- save button starts-->
                                                                <div class="row text-right">
                                                                    <div class="col-md-12">
                                                                        <b-button type="submit" class="btn btn-primary btn-sm" variant="primary">Save</b-button>
                                                                    </div>
                                                                </div>
                                                                <!-- save button ends -->
                                                            </form>

                                                           

                                                            <!-- Next Step Button Ends  -->
                                                        </b-card>
                                                        <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f">
                                                            <form @submit.prevent="submitEditForm">
                                                                <div class="form-group">
                                                                    <div class="row">
                                                                        <!-- floating input starts -->
                                                                        <div class="col-sm-6">
                                                                            <div class="floating-label">
                                                                                <input class="floating-input form-control" type="text" placeholder=" " v-model="name" @input="name = name.replace(/[^a-zA-Z\s]/g, '')" id="name" />
                                                                                <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                                                    <i class="material-icons" style="font-size: 20px">account_circle</i>
                                                                                </span>
                                                                                <label class="lbl-label">Facilitator Name</label>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-sm-6 ">
                                                                            <div class="floating-label">
                                                                                <input class="floating-input form-control" v-mask="'(9999)-9999999'" type="text" placeholder=" " v-model="mobilenumber" id="contact" />

                                                                                <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                                                    <i class="material-icons" style="font-size: 20px">call</i>
                                                                                </span>
                                                                                <label class="lbl-label">Contact</label>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6 mt-2">
                                                                            <div class="form-group">
                                                                                <label style="font-weight: 700" for="first">
                                                                                    Department
                                                                                </label>
                                                                                <selectize id="select-state department" class="text-capitalize" v-model="department" :settings="departmentSetting" :searchable="true">
                                                                                    <option v-for="(item,index) in departmentArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                        {{item.title}}
                                                                                    </option>
                                                                                </selectize>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6 mt-2">
                                                                            <div class="form-group">
                                                                                <label style="font-weight: 700" for="first">
                                                                                    Designation
                                                                                </label>
                                                                                <selectize id="select-state designation" class="text-capitalize" v-model="designation" :settings="designationSetting" :searchable="true">
                                                                                    <option v-for="(item,index) in designationArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                        {{item.title}}
                                                                                    </option>
                                                                                </selectize>
                                                                            </div>
                                                                        </div>

                                                                        <div class="col-md-6">
                                                                            <div class="form-group">
                                                                                <label style="font-weight: 700" for="first">
                                                                                    Nationality
                                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                                </label>
                                                                                <selectize id="select-state nationality" class="text-capitalize" v-model="nationality" :searchable="true">
                                                                                    <option v-for="(item,index) in nationalityArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                        {{item.name}}
                                                                                    </option>
                                                                                </selectize>
                                                                            </div>
                                                                        </div>

                                                                        <div class="col-md-6">
                                                                            <div class="form-group">
                                                                                <label style="font-weight: 700" for="first">
                                                                                    Qualification
                                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                                </label>
                                                                                <selectize id="select-state qualification" class="text-capitalize" v-model="academicqualifications" :searchable="true">
                                                                                    <option v-for="(item,index) in qualificationArr" :key="index" :value="item.id" class="text-capitalize">
                                                                                        {{item.title}}
                                                                                    </option>
                                                                                </selectize>
                                                                            </div>
                                                                        </div>

                                                                        <div class="col-sm-6 mt-3">
                                                                            <div class="floating-label">
                                                                                <input class="floating-input form-control" v-mask="'(99999) 9999999-9'" type="text" placeholder=" " v-model="cnic" :disabled="nationality != 1" id="cnic" />

                                                                                <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                                                    <i class="material-icons" style="font-size: 20px">credit_card</i>
                                                                                </span>
                                                                                <label class="lbl-label">CNIC</label>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-sm-6 mb-2 mt-3">
                                                                            <div class="floating-label">
                                                                                <input class="floating-input form-control" type="text" placeholder="" v-model="address" id="address" />

                                                                                <span class="lbl-label" style="
                                            float: right;
                                            padding: 0px 5px;
                                            margin-top: -30px;
                                            color: #ccc;
                                          ">
                                                                                    <i class="material-icons" style="font-size: 20px">home</i>
                                                                                </span>
                                                                                <label class="lbl-label">
                                                                                    Address
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-sm-6 mt-3">
                                                                            <div class="floating-label">
                                                                                <input class="floating-input form-control" v-model="passport" type="text" placeholder=" " id="passport" />
                                                                                <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                                                    <i class="material-icons" style="font-size: 20px">credit_card</i>
                                                                                </span>
                                                                                <label class="lbl-label">Passport</label>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-sm-6 mt-3">
                                                                            <div class="floating-label">
                                                                                <input class="floating-input form-control" disabled type="email" placeholder=" " v-model="email" id="email" />

                                                                                <span class="lbl-label" style="
                                              float: right;
                                              padding: 0px 5px;
                                              margin-top: -30px;
                                              color: #ccc;
                                            ">
                                                                                    <i class="material-icons" style="font-size: 20px">email</i>
                                                                                </span>
                                                                                <label class="lbl-label">Email</label>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6 col-lg-6 mt-3">
                                                                            <div class="floating-label">
                                                                                <input class="floating-input form-control" v-model="code" type="text" placeholder=" " id="code" />

                                                                                <span class="lbl-label" style="
                                              float: right;
                                              margin-top: -25px;
                                              padding: 0px 5px;
                                              color: #ccc;
                                            ">
                                                                                    <i class="material-icons" style="font-size: 20px">code</i>
                                                                                </span>
                                                                                <label class="lbl-label">
                                                                                    Employee Code (This will use as
                                                                                    password)
                                                                                </label>
                                                                            </div>
                                                                        </div>

                                                                        <div class="col-md-6 col-lg-6 mb-2 mt-3">
                                                                            <!-- Gender starts -->
                                                                            <div style="padding-left: 5px; display: inline-flex; color: black">
                                                                                <label class="col-form-label" style="font-weight: 700;">
                                                                                    Gender
                                                                                    <span style="color:rgba(255, 0, 0, 0.78)">*</span>
                                                                                </label>
                                                                                <div style="margin: 7px 6px 2px 6px">
                                                                                    <vs-radio v-model="gender" vs-name="radios1" vs-value="male" id="male">Male</vs-radio>
                                                                                </div>
                                                                                <div style="margin: 7px 6px 2px 6px">
                                                                                    <vs-radio v-model="gender" vs-name="radios1" vs-value="female" id="fmale">Female</vs-radio>
                                                                                </div>
                                                                                <div style="margin: 7px 6px 2px 6px">
                                                                                    <vs-radio v-model="gender" vs-name="radios1" vs-value="rather not say" id="gender">Rather not say</vs-radio>
                                                                                </div>
                                                                            </div>
                                                                            <!-- Gender ends -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <input type="hidden" v-model="userId" />
                                                                <input type="hidden" v-model="primaryUserId" />
                                                                <div class="form-group">
                                                                    <div class="row">
                                                                        <div class="col-sm-12">
                                                                            <!-- add button starts-->
                                                                            <b-button type="submit" class="save-btn" variant="primary" id="update">Update</b-button>
                                                                            <b-button v-if="!isForm" @click="closeEditForm" variant="outline-info" id="cancel">Cancel</b-button>
                                                                            <!-- add button ends -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </b-card>
                                                        <div class="table-responsive">
                                                            <div class="col-sm-12">
                                                                <!-- new form popup starts -->
                                                                <b-card>
                                                                    <div class="form-group">
                                                                        <div class="row">
                                                                            <div class="col-sm-12">
                                                                                <table class="table table-hover">
                                                                                    <tr>
                                                                                        <th>Sr#</th>
                                                                                        <th>Facilitator Name</th>
                                                                                        <th>CNIC</th>
                                                                                        <th>Contact Number</th>
                                                                                        <th>Email</th>
                                                                                        <th v-if="isDateValid">Action</th>
                                                                                    </tr>

                                                                                    <tr v-for="(
                                                item, index
                                              ) in newTrainer" v-bind:key="item.trainer.id">
                                                                                        <td>{{ index + 1 }}</td>
                                                                                        <td class="text-capitalize">
                                                                                            {{ item.trainer.name ? item.trainer.name : '--' }}
                                                                                        </td>

                                                                                        <td>
                                                                                            {{ item.trainer.cnic ? item.trainer.cnic : '--' }}
                                                                                        </td>

                                                                                        <td>
                                                                                            {{ item.trainer.mobile ? item.trainer.mobile : '--' }}
                                                                                        </td>

                                                                                        <td>
                                                                                            {{ item.trainer.email ? item.trainer.email : '--' }}
                                                                                        </td>

                                                                                        <td v-if="isDateValid">
                                                                                            <a @click="
                                                    editRecord(item.trainer.id)
                                                  ">
                                                                                                <vs-icon class="mr-1" icon="edit" style="
                                                      color: #007bff;
                                                      font-size: 20px;
                                                      font-weight: 600;
                                                      cursor: pointer;
                                                    "></vs-icon>
                                                                                            </a>
                                                                                            <a @click="
                                                    unassignedTraining(
                                                      item.trainer.id
                                                    )
                                                  ">
                                                                                                <vs-icon class="mr-1" icon="clear" style="
                                                      color: #ff0000c7;
                                                      font-size: 20px;
                                                      font-weight: 600;
                                                      cursor: pointer;
                                                    "></vs-icon>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </b-card>
                                                                <!-- new form popup ends -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </vs-tab>
                                                <vs-tab label="Registered Facilitators'">
                                                    <div class="table-responsive">
                                                        <div class="col-sm-12">
                                                            <!-- new form popup starts -->
                                                            <b-card>
                                                                <div class="form-group">
                                                                    <div class="row">
                                                                        <div class="col-sm-12">
                                                                            <div class="col-sm-4 float-left mb-2 p-0">
                                                                                <input type="text" placeholder="Search ..." v-model="searchQuery" class="search_button form-control form-control-sm" @keyup.enter="filterData" @input="callSearch" />
                                                                                <button class="clear_button" @click="getAllTraining" type="button">
                                                                                    Search
                                                                                </button>
                                                                                <i v-if="searchQuery !== ''" class="material-icons close_icon" @click="clearSearch">close</i>
                                                                            </div>
                                                                            <div class="col-sm-4 float-right mb-2 p-0">
                                                                                <Pagination :current-page="currentPage" :record-limit="recordLimit" :total-counts="totalCounts" @prev-page="prevPage" @next-page="nextPage" @go-to-page="goToPage" />
                                                                                <div class="page-count">
                                                                                    {{((currentPage-1)*50)+registeredTrainerArr.length}}
                                                                                    Records out of
                                                                                    {{this.totalCounts}}
                                                                                </div>
                                                                            </div>

                                                                            <table class="table table-hover">
                                                                                <tr style="color: #000 !important">
                                                                                    <th>Sr#</th>
                                                                                    <th>Facilitator Name</th>
                                                                                    <th>CNIC</th>
                                                                                    <th>Email</th>
                                                                                    <th>Contact Number</th>
                                                                                    <th>Department</th>
                                                                                    <th>Designation</th>
                                                                                    <th v-if="isDateValid">Action</th>
                                                                                </tr>

                                                                                <tr v-for="(item, index) in registeredTrainerArr" v-bind:key="item.id">
                                                                                    <td>{{ index + 1 + offSet }}</td>
                                                                                    <td class="text-capitalize">
                                                                                        {{ item.name ? item.name : '--' }}
                                                                                    </td>

                                                                                    <td>
                                                                                        {{ item.cnic ? item.cnic : '--' }}
                                                                                    </td>

                                                                                    <td>
                                                                                        {{ item.email ? item.email : '--' }}
                                                                                    </td>

                                                                                    <td>
                                                                                        {{ item.mobile ? item.mobile : '--' }}
                                                                                    </td>
                                                                                    <td>
                                                                                        {{ getDepartmentName(item.trainer_user_id.department_id) }}
                                                                                    </td>
                                                                                    <td>
                                                                                        {{ getDesignationName(item.trainer_user_id.designation_id) }}
                                                                                    </td>

                                                                                    <td v-if="isDateValid && item.status == 'found'">
                                                                                        <span>
                                                                                            <a @click="
                                                    unassignedTraining(item.id)
                                                  ">
                                                                                                <vs-chip color="danger">Un Select</vs-chip>
                                                                                            </a>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td v-else-if="isDateValid">
                                                                                        <a @click="
                                                  assignedTraining(item.id)
                                                ">
                                                                                            <vs-chip color="success">Select for Training</vs-chip>
                                                                                        </a>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-card>
                                                            <!-- new form popup ends -->
                                                        </div>
                                                    </div>
                                                </vs-tab>
                                            </vs-tabs>

                                            <!-- row 1 starts  -->
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Selectize from "vue2-selectize";
import Sidebar from "./Sidebar";
import axios from "axios";
import Pagination from '../../../components/Pagination.vue';
import {
    formatDateRange
} from "../../../utils/DateFormate";

export default {
    data: () => ({
        currentPage: 1,
        recordLimit: 50,
        totalCounts: 0,
        offSet: 0,
        searchQuery: "",
        isSidebar: false,
        isEditForm: false,
        whichSelect: 0,
        passport: "",
        trainingId: "",
        trainingCode: "",
        valuesArray: [],
        updateTraining: [],
        radios1: "",
        gender: "",
        // success: "",
        inValid: [],
        isForm: true,
        isFormData: false,
        address: "",
        mobilenumber: "",
        cnic: "",
        name: "",
        email: "",
        tags: [],
        role: "",
        rolesArr: [],
        roleuser: "",
        primaryUserId: "",
        nationality: "",
        academicqualifications: "",
        department: null,
        departmentArr: [],
        departmentSetting: {
            maxItems: 1,
            plugins: ["remove_button"],
            placeholder: "Select department here"
        },
        designation: null,
        designationArr: [],
        designationSetting: {
            maxItems: 1,
            plugins: ["remove_button"],
            placeholder: "Select designation here"
        },
        checkTraining: [],
        sessionByArray: [],
        textarea: "",
        counterDanger: false,
        mydate: "",
        startDate: "",
        endDate: "",
        code: "",
        countryArr: [],
        provinceArr: [],
        districtArr: [],
        nationalityArr: [],
        qualificationArr: [],
        degreenameArr: [],
        newTrainer: [],
        registeredTrainerArr: [],
        training_status: "",
        trainingEndDate: "",
        isDateValid: true,
    }),

    mounted() {
        axios.defaults.headers["Authorization"] = localStorage.getItem("token");
        this.trainingCode = this.$route.query.trainingId;

        //Select all countries

        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode
            )
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.updateTraining = response.data.training;
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;
                this.trainingEndDate = response.data.training.enddate;
                this.allTrainer();
                this.getTrainerTraning();
                this.getAllTraining();
                this.dateCheck();
            });
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/countries/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.countryArr = response.data;
                // this.provinceArr=response.data;
            });
        //get result of trainers
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainers/all/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.valuesArray = response.data;
            });

        //select all degree names
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.qualificationArr = response.data;
            });
        // department
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/user/departments/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.departmentArr = response.data;
            });
        //designation
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/designations/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.designationArr = response.data;
            });
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainers/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.sessionByArray = response.data;
            });
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainer/role/get")
            .then((response) => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg(
                        "Your are Unauthorized. Need to Login Again"
                    );
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                // this.rolesArr = response.data;
                this.role = response.data[0].id;
            });

        // Nationality
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/nationalities/get")
            .then(response => {

                this.closeLoading();
                this.nationalityArr = response.data;
            });

    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        Selectize,
        Pagination,
    },

    methods: {
        formatDateRange,
        // onclick show wizard steps
        trainingInformation() {
            this.$router.push({
                path: "/dashboard/programOfficer/training-information",
                query: {
                    trainingId: this.trainingCode
                },
            });
        },
        trainingAgenda() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/training-agenda",
                    query: {
                        trainingId: this.trainingCode
                    },
                });
            }
        },
        trainingMaterial() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/wizardUploadMaterial",
                    query: {
                        trainingId: this.trainingCode
                    },
                });
            }
        },
        trainingAssessment() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else {
                this.$router.push({
                    path: '/dashboard/programOfficer/training-assesment',
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }

        },
        traineeReg() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/trainee-registration",
                    query: {
                        trainingId: this.trainingCode
                    },
                });
            }
        },
        assessmentReviewFunction() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/assesment-review",
                    query: {
                        trainingId: this.trainingCode
                    },
                });
            }
        },
        trainingCompletion() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/wizard-completion",
                    query: {
                        trainingId: this.trainingCode
                    },
                });
            }
        },

        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.resetForm();
        },
        getAllTraining() {
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainer/get/all/" +
                    this.trainingId, {
                        "searchText": this.searchQuery,
                        "offSet": this.offSet,
                    }
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.registeredTrainerArr = response.data.trainers;
                    this.totalCounts = response.data.totalCounts;
                    this.recordLimit = response.data.recordLimit;
                    this.offSet = response.data.offSet;
                });
        },
        assignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH + "/training/assigned/trainer", {
                        trainingId: this.updateTraining.id,
                        trainee: id,
                    }
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg("Assigned Training successfully!");
                        this.getAllTraining();
                        this.allTrainer();
                    }
                });
        },
        unassignedTraining(id) {
            this.openLoading();
            axios
                .post(
                    process.env.VUE_APP_BASE_PATH + "/training/un-assigned/trainer", {
                        trainingId: this.updateTraining.id,
                        trainee: id,
                    }
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        this.$toasted.global.successMsg(
                            "Training Un Assigned successfully!"
                        );
                        this.getAllTraining();
                        this.allTrainer();
                    }
                });
        },

        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH + "/trainer/user/" + id + "/edit"
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.name = response.data.name;
                        this.code = response.data.trainer_user_id.code;
                        this.mobilenumber = response.data.mobile;
                        this.email = response.data.email;
                        this.gender = response.data.gender;
                        this.cnic = response.data.cnic;
                        this.passport = response.data.passport;
                        this.primaryUserId = response.data.trainer_id_user;
                        this.userId = id;
                        this.nationality = response.data.nationality;
                        this.address = response.data.address;
                        this.academicqualifications = response.data.academicqualifications;
                        this.designation = response.data.designation;
                        this.department = response.data.trainer_user_id.department_id;
                        // this will scrollTop to edit form
                        window.scrollTo(0, 0);
                    }
                });
        },
        deleteRecord(id) {
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(process.env.VUE_APP_BASE_PATH + "/trainer/delete", {
                                id: id,
                            })
                            .then((response) => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg(
                                        "Record has been deleted successfully!"
                                    );
                                    this.allTrainer();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch((error) => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        getTrainerTraning: function getAllTraining() {
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/all/trainer/training/get/" +
                    this.trainingId
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    // this.rolesArr = response.data;
                    this.checkTraining = response.data;
                });
        },

        allTrainer: function allTrainer() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainer/show/training/" +
                    this.trainingId
                )
                .then((response) => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg(
                            "Your are Unauthorized. Need to Login Again"
                        );
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.newTrainer = response.data;
                });
        },
        openLoading() {
            this.$vs.loading({
                type: "material",
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true,
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
            });
        },
        showinputvalue: function (event) {
            this.name = event.target.value;
        },
        //Quick training
        quickRegistration(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }

            if (!this.email) {
                this.inValid.push("Email is required.");
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.inValid.push("Invalid email format.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.nationality) {
                this.inValid.push("Nationality is required.");
            }
            if (this.nationality == 1) {
                var cnic_var = this.cnic;
                if (cnic_var == '') {
                    this.inValid.push("CNIC is required.");
                } else {
                    if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                        cnic_var = cnic_var.replace(/_/g, "");
                        if (cnic_var.length < 17) {
                            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                        }
                    }
                }
            }

            if (!this.academicqualifications) {
                this.inValid.push("Qualifications is required.");
            }

            if (!this.code) {
                this.inValid.push("Code is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
                    this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
                }
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/programofficer/quick/registeration/trainer", {
                            //insert User informatiion in user table
                            name: this.name,
                            code: this.code,
                            role: this.role,
                            contactNo: this.mobilenumber,
                            email: this.email,
                            training_id: this.trainingId,
                            gender: this.gender,
                            nationality: this.nationality,
                            address: this.address,
                            academicqualifications: this.academicqualifications,
                            designation: this.designation,
                            department_name: this.department,
                            //insert trainee quick information in trainee table
                            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                            cnic: this.cnic,
                            passport: this.passport,
                            type: "Quick Registration",
                        }
                    )
                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been added successfully!");
                            self.resetForm();
                            self.allTrainer();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }
        },
        submitEditForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.name) {
                this.inValid.push("Name is required.");
            }

            if (!this.email) {
                this.inValid.push("Email is required.");
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.inValid.push("Invalid email format.");
            }
            if (!this.gender) {
                this.inValid.push("Gender is required.");
            }
            if (!this.nationality) {
                this.inValid.push("Nationality is required.");
            }
            if (this.nationality == 1) {
                var cnic_var = this.cnic;
                if (cnic_var == '') {
                    this.inValid.push("CNIC is required.");
                } else {
                    if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
                        cnic_var = cnic_var.replace(/_/g, "");
                        if (cnic_var.length < 17) {
                            this.inValid.push("Must be valid CNIC, 16101-1114812-3");
                        }
                    }
                }
            }

            if (!this.code) {
                this.inValid.push("Code is required.");
            }
            if (!this.academicqualifications) {
                this.inValid.push("Qualifications is required.");
            }
            var phone_no1 = this.mobilenumber;
            if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
                this.inValid.push("Must be valid Number, 0345-9992229");
            } else {
                phone_no1 = phone_no1.replace(/_/g, "");
                if (phone_no1.length < 14) {
                    this.inValid.push("Must be valid Number, 0345-9992229");
                }
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }

            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/trainer/update", {
                        //insert User informatiion in user table

                        name: this.name,
                        code: this.code,
                        role: this.role,
                        contactNo: this.mobilenumber,
                        email: this.email,
                        gender: this.gender,
                        nationality: this.nationality,
                        address: this.address,
                        academicqualifications: this.academicqualifications,
                        designation: this.designation,
                        department_name: this.department,
                        //insert trainee quick information in trainee table
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        cnic: this.cnic,
                        passport: this.passport,
                        type: "Quick Registration",
                        id: this.userId,
                        primaryUserId: this.primaryUserId,
                    })

                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainer();

                            this.isForm = true;
                            this.isEditForm = false;
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.name = "";
            this.cnic = "";
            this.code = "";
            this.passport = "";
            this.gender = "";
            this.mobilenumber = "";
            this.email = "";
            this.address = "";
            this.department = "";
            this.designation = "";
            this.certificate = "";
            this.training_name = "";
            this.training_code = "";
            this.nationality = "";
            this.academicqualifications = "";
        },
        successUpload() {
            this.$vs.notify({
                color: "primary",
                title: "Upload Success",
                text: "Your file is uploaded Successfully.",
            });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.offSet = this.currentPage * 50 - 50
                this.getAllTraining();
            }
        },
        nextPage() {
            if (this.currentPage * this.recordLimit < this.totalCounts) {
                this.currentPage++;
                this.offSet = this.currentPage * 50 - 50
                this.getAllTraining();
            }
        },
        goToPage(page) {
            this.currentPage = page;
            this.offSet = this.currentPage * 50 - 50
            this.getAllTraining();
        },
        filterData() {
            this.currentPage = 1
            this.offSet = 0
            this.getAllTraining();
        },
        clearSearch() {
            this.currentPage = 1
            this.offset = 0
            this.searchQuery = ""
            this.getAllTraining();
        },
        callSearch() {
            if (this.searchQuery.length == 0) {
                this.getAllTraining();
            }
        },
        dateCheck() {
            const today = new Date();
            const dateString = this.trainingEndDate;
            const [day, month, year] = dateString.split("-");

            // Create a new date object for the target date
            const targetDate = new Date(`${year}-${month}-${day}`);

            // Add 3 days to the target date
            targetDate.setDate(targetDate.getDate() + 6);

            today.setHours(0, 0, 0, 0);
            targetDate.setHours(0, 0, 0, 0);

            // Compare today's date with the updated target date
            if (today > targetDate) {
                this.isDateValid = false;
            }

        },
        getDepartmentName(departmentId) {
            console.log(departmentId);
            if (!departmentId) return "--"; // agar null ya empty hai
            const dept = this.departmentArr.find(d => d.id == departmentId);
            return dept ? dept.title : "--"; // agar match na mile to --
        },
        getDesignationName(designationId) {
            if (!designationId) return "--"; // agar null ya empty hai
            const deg = this.designationArr.find(d => d.id == designationId);
            return deg ? dept.title : "--"; // agar match na mile to --
        }
    },

};
</script>

<style scoped>
.vs-breadcrumb {
    font-size: 18px !important;
    font-weight: 600 !important;
}

#progressbar .completed {
    color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
    background: #06a6e0;
}

#grad1 {
    background-color: #fff;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #f4f4f4;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
}

#progressbar .active {
    color: #000000;
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 9.5%;
    text-align: center;
    float: left;
    position: relative;
}

#progressbar #NewTraining:before {
    content: "1";
}

#progressbar #PoAssignment:before {
    content: "2";
}

#progressbar #TrainingInformation:before {
    content: "3";
}

#progressbar #TrainerRegistration:before {
    content: "4a";
}

#progressbar #TrainingAgenda:before {
    content: "4b";
}

#progressbar #Trainingmaterial:before {
    content: "4c";
}

#progressbar #TrainingAssessments:before {
    content: "4d";
}

#progressbar #TraineeRegistration:before {
    content: "4e";
}

#progressbar #AssessmentReview:before {
    content: "5";
}

#progressbar #Completion:before {
    content: "6";
}

#progressbar li:before {
    width: 35px;
    height: 35px;
    line-height: 30px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
}

#progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 17px;
    z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
    background: #000000;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.card-body {
    background-color: #f4f4f4 !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    padding: 5px !important;
    /* padding-right: 10px; */
    cursor: pointer;
}
</style><style>
span.text-chip.vs-chip--text {
    margin-left: 0px !important;
}

.con-vs-chip.vs-chip-danger.con-color,
.con-vs-chip.vs-chip-success.con-color,
.con-vs-chip.vs-chip-warning.con-color {
    padding: 5px !important;
}

.vuesax-app-is-ltr .con-vs-chip {
    float: none !important;
}

.form-row {
    border: none !important;
    padding: 0px !important;
}

.search_button {
    position: relative
}

.clear_button {
    position: absolute;
    right: 0px;
    height: 31px;
    top: 0px;
    width: 80px;
    border-radius: 5px;
    background-color: #06a6e0;
    border: 1px solid #06a6e0;
    color: #ffffff;
    font-size: 15px;
}

.close_icon {
    position: absolute;
    right: 85px;
    top: 4px;
    color: #dc3545;
    font-weight: bold;
    cursor: pointer;
    font-size: 24px !important;
}

.page-count {
    text-align: end;
    font-size: 15px;
    color: #06a6e0;
}
</style>
